import { splitProps, type Component } from 'solid-js';


const baseClasses = 'relative flex items-center justify-between p-0.5 scrollbar-hide';
const borderClasses: Record<'top' | 'bottom' | 'none', string> = { top: 'border-t', bottom: 'border-b', none: '' };
const sectionClasses = 'flex items-center h-7';

function mergeClasses(...classes: (string | undefined)[]): string {
    return classes.filter(Boolean).join(' ');
}

export interface ToolbarProps {
    class?: string;
    border?: 'top' | 'bottom' | 'none';
    children?: any;
    ref?: HTMLDivElement | ((el: HTMLDivElement) => void);
    [key: string]: any;
}

const Toolbar: Component<ToolbarProps> = (props) => {
    const [local, others] = splitProps(props, ['class', 'border', 'ref', 'children']);

    const classes = () => mergeClasses(baseClasses, borderClasses[local.border ?? 'bottom'], local.class);

    return (
        <div class={classes()} ref={local.ref} {...others}>
            {local.children}
        </div>
    );
};

const ToolbarSection: Component<ToolbarProps> = (props) => {
    const [local, others] = splitProps(props, ['class', 'ref', 'children']);

    const classes = () => mergeClasses(sectionClasses, local.class);

    return (
        <div class={classes()} ref={local.ref} {...others}>
            {local.children}
        </div>
    );
};

export { Toolbar, ToolbarSection };
